
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import doctorData from "../pages/Doctor1.json"; // Adjust path to your JSON file

const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

const DoctorsSection = React.memo(() => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const processedDoctors = useMemo(() => {
    if (doctorData?.doctors?.length) {
      return doctorData.doctors.map((doc) => ({
        ...doc,
        slug: slugify(doc.name),
        image: doc.profileImage || doc.image || "/images/default-doctor.webp",
        shortDescription: doc.description.slice(0, 150) + "..."
      }));
    }
    return [];
  }, []);

  useEffect(() => {
    // Instead of fetching from backend, use processed doctors directly
    setDoctors(processedDoctors);
    setError(processedDoctors.length ? null : "No doctors data found.");
    setLoading(false);
  }, [processedDoctors]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-48">
        <div className="spinner"></div>
        <p className="ml-4">Loading Doctors...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-48 text-red-600">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <>
      <div className="therapist-team bg-radius-section" id="doctors">
        <div className="container">
          <div className="row section-row text-center">
            <div className="col-lg-12">
              <div className="section-title mb-0">
                <h2 className="text-anime-style-3" data-cursor="-">
                  Meet Our Doctors
                </h2>
                <p class="text-muted fs-5">
  Our team comprises highly experienced and specialized doctors, each committed to providing the highest standard of patient care.
</p>

              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            {doctors.map((doctor, idx) => (
              <div key={idx} className="col-lg-4 col-md-6">
                <div className="team-member-item wow fadeInUp">
                  <div className="team-image">
                    <figure className="image-anime">
                      <img
                        src={doctor.image}
                        alt={doctor.name ? `Dr. ${doctor.name}` : "Doctor Image"}
                        loading="lazy"
                      />
                    </figure>
                    <div className="team-social-icon">
                      <Link
                        to={`/doctor/${doctor.slug}`}
                        title={`View profile of ${doctor.name}`}
                        className="btn-default"
                      >
                        <span>view profile</span>
                      </Link>
                    </div>
                  </div>
                  <div className="team-content">
                    <h3>{doctor.name}</h3>
                    <p className="mb-2">{doctor.position || doctor.designation}</p>
                    <p>{doctor.shortDescription}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
});

export default DoctorsSection;
